// Persistent offline mutation queue (IndexedDB via offlineDb).
import { idb } from "@/lib/offlineDb";

export const addOp = (op) => idb.put("queue", op);
export const allOps = () => idb.all("queue");
export const removeOp = (operationId) => idb.del("queue", operationId);
export const updateOp = (op) => idb.put("queue", op);
export const countOps = () => allOps().then((a) => a.length).catch(() => 0);

// Permanently-rejected ops kept for the "Nicht synchronisiert" list.
export const addFailed = (op) => idb.put("failed", op);
export const allFailed = () => idb.all("failed");
export const removeFailed = (operationId) => idb.del("failed", operationId);
export const clearFailed = () => idb.clear("failed");
export const countFailed = () => allFailed().then((a) => a.length).catch(() => 0);
